import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../Layout/Layout';
import PricingCard from './PricingCard';
import { PRICING_PLANS } from './pricingPlans';
import './Pricing.css';

const Pricing = () => {
    return (
        <Layout>
            <div className="pricing-page">
                <header className="pricing-page-header">
                    <span className="pricing-page-eyebrow">Simple, transparent pricing</span>
                    <h1 className="pricing-page-title">Plans that scale with your trading</h1>
                    <p className="pricing-page-subtitle">
                        Every plan is tied to your account limits for bots, monitors, and monthly backtests.
                        Start free, then upgrade when you need more automation capacity.
                    </p>
                </header>

                <div className="pricing-grid">
                    {PRICING_PLANS.map((plan) => (
                        <PricingCard key={plan.id} plan={plan} />
                    ))}
                </div>

                <div className="pricing-page-limits">
                    <h3 className="pricing-page-limits-title">How limits work</h3>
                    <p className="pricing-page-limits-text">
                        <strong>Active bots</strong> count your running automations (grid, scheduled, and algo setups).{' '}
                        <strong>Monitors</strong> track live price and indicator conditions.{' '}
                        <strong>Backtests</strong> reset each calendar month.{' '}
                        Paid plans include futures trading; the Free plan is spot-only.{' '}
                        Ready to subscribe?{' '}
                        <Link to="/subscription" className="text-primary">Go to checkout</Link>
                        {' '}or{' '}
                        <Link to="/contact" className="text-primary">contact us</Link>
                        {' '}for help choosing a plan.
                    </p>
                </div>

                <p className="pricing-page-note">
                    All prices in USD, billed monthly. Limits reflect your NeuraTrader account tier and are enforced platform-wide.
                </p>
            </div>
        </Layout>
    );
};

export default Pricing;